import React, { Component } from "react";
import { MdExpandMore, MdInfo } from "react-icons/md";
import showInfo from "./show_info";

const statusItem = require("../status.json");

class ListItems extends Component {
  render() {
    const { items, selectedContent } = this.props;
    return (
      <React.Fragment>
        <div className="container">
          <div className="item-content">
            <div
              className="card-panel white lighten-5 z-depth-1"
              style={{
                width: "100%",
                margin: "auto",
                height: "auto",
                display: "block",
                position: "relative",
                boxShadow:
                  "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                fontSize: "1.1rem",
                marginTop: "205px"
              }}
            >
              {selectedContent.length > 0 ? (
                selectedContent.map((item, i) => (
                  <React.Fragment key={i}>
                    <div
                      className="accordion md-accordion accordion-blocks"
                      id="accordionEx78"
                      role="tablist"
                      aria-multiselectable="true"
                      style={{
                        alignContent: "left",
                        backgroundColor: "white",
                        boxShadow:
                          "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                        display: "block",
                        margin: "auto"
                      }}
                    >
                      <div className="card white" id={"card" + i}>
                        <div
                          className="card-header"
                          role="tab"
                          id={"headingUnfiled" + i}
                          style={
                            item.status === 1
                              ? {
                                  backgroundColor: "#357ae8"
                                }
                              : item.status === 2
                              ? {
                                  backgroundColor: "tomato"
                                }
                              : item.status === 3
                              ? {
                                  backgroundColor: "#357ae8"
                                }
                              : item.status === 4
                              ? {
                                  backgroundColor: "gray"
                                }
                              : {
                                  backgroundColor: "#357ae8"
                                }
                          }
                        >
                          <a
                            data-toggle="collapse"
                            data-parent={"#card" + i}
                            href={"#collapseUnfiled" + i}
                            aria-expanded="true"
                            aria-controls="collapseUnfiled"
                          >
                            <h5 className="mt-4 mb-0">
                              <span style={{ color: "white" }}>
                                Item
                                <p className="left" style={{ color: "white" }}>
                                  ID: {item.id_item}
                                </p>
                                <p className="right" style={{ color: "white" }}>
                                  <MdExpandMore />
                                </p>
                              </span>
                            </h5>
                          </a>
                        </div>
                        <div
                          id={"collapseUnfiled" + i}
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={"headingUnfiled" + i}
                          data-parent={"#card" + i}
                        >
                          <div className="card-body">
                            <React.Fragment>
                              <div
                                className="row justify-content-center"
                                style={{
                                  display: "block",
                                  margin: "auto",
                                  width: "100%"
                                }}
                              >
                                <div className="col s12">
                                  <table className="table table-adapt-query table-sm table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">ID Movimentação</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Destinatário</th>
                                        <th scope="col">Descrição</th>
                                        <th scope="col">Patrimônio</th>
                                        <th scope="col">Observação</th>
                                        <th scope="col">
                                          <i>Status</i>
                                        </th>
                                        <th scope="col">
                                          <i>Info</i>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr key={i}>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          {item.id_movimentacao}
                                        </td>
                                        <td>{item.tipo.toUpperCase()}</td>
                                        <td>
                                          {item.destino
                                            .toUpperCase()
                                            .replace(".", " ")}
                                        </td>
                                        <td>
                                          {item.descricao &&
                                            (item.descricao.length <= 15 ? (
                                              item.descricao
                                            ) : (
                                              <textarea
                                                style={{ border: "none" }}
                                                className="form-control white"
                                                id="view_descricao"
                                                maxLength="100"
                                                value={item.descricao}
                                                readOnly
                                              />
                                            ))}
                                        </td>
                                        <td>
                                          {item.patrimonio ? (
                                            item.patrimonio.length <= 15 ? (
                                              item.patrimonio
                                            ) : (
                                              <textarea
                                                style={{ border: "none" }}
                                                className="form-control white"
                                                id="view_patrimonio"
                                                maxLength="30"
                                                value={item.patrimonio}
                                                readOnly
                                              />
                                            )
                                          ) : (
                                            "----"
                                          )}
                                        </td>
                                        <td>
                                          {item.observacao ? (
                                            item.observacao.length <= 15 ? (
                                              item.observacao
                                            ) : (
                                              <textarea
                                                style={{ border: "none" }}
                                                className="form-control white"
                                                id="view_observacao"
                                                maxLength="1000"
                                                value={item.observacao}
                                                readOnly
                                              />
                                            )
                                          ) : (
                                            "----"
                                          )}
                                        </td>
                                        <td>
                                          {statusItem
                                            .filter(
                                              status =>
                                                status.id_status === item.status
                                            )
                                            .map((status, k) => (
                                              <span key={k}>
                                                <i
                                                  style={
                                                    item.status === 4
                                                      ? {
                                                          color: "red"
                                                        }
                                                      : item.status === 3
                                                      ? {
                                                          color: "green"
                                                        }
                                                      : item.status === 2
                                                      ? {
                                                          color: "tomato"
                                                        }
                                                      : item.status === 1
                                                      ? {
                                                          color: "#357ae8"
                                                        }
                                                      : {
                                                          color: "black"
                                                        }
                                                  }
                                                >
                                                  {status.status.toUpperCase()}
                                                </i>
                                              </span>
                                            ))}
                                        </td>
                                        <td>
                                          <MdInfo
                                            style={{
                                              fontSize: "1.2rem"
                                            }}
                                            onClick={() => showInfo(item)}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </React.Fragment>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              ) : selectedContent && items.length > 0 ? (
                items.map((item, i) => (
                  <React.Fragment key={i}>
                    <div
                      className="accordion md-accordion accordion-blocks"
                      id="accordionEx78"
                      role="tablist"
                      aria-multiselectable="true"
                      style={{
                        alignContent: "left",
                        backgroundColor: "white",
                        boxShadow:
                          "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                        display: "block",
                        margin: "auto"
                      }}
                    >
                      <div className="card white" id={"card" + i}>
                        <div
                          className="card-header"
                          role="tab"
                          id={"headingUnfiled" + i}
                          style={
                            item.status === 1
                              ? {
                                  backgroundColor: "#357ae8"
                                }
                              : item.status === 2
                              ? {
                                  backgroundColor: "tomato"
                                }
                              : item.status === 3
                              ? {
                                  backgroundColor: "#357ae8"
                                }
                              : item.status === 4
                              ? {
                                  backgroundColor: "gray"
                                }
                              : {
                                  backgroundColor: "#357ae8"
                                }
                          }
                        >
                          <a
                            data-toggle="collapse"
                            data-parent={"#card" + i}
                            href={"#collapseUnfiled" + i}
                            aria-expanded="true"
                            aria-controls="collapseUnfiled"
                          >
                            <h5 className="mt-4 mb-0">
                              <span style={{ color: "white" }}>
                                Item
                                <p className="left" style={{ color: "white" }}>
                                  ID: {item.id_item}
                                </p>
                                <p className="right" style={{ color: "white" }}>
                                  <MdExpandMore />
                                </p>
                              </span>
                            </h5>
                          </a>
                        </div>
                        <div
                          id={"collapseUnfiled" + i}
                          className="collapse show"
                          role="tabpanel"
                          aria-labelledby={"headingUnfiled" + i}
                          data-parent={"#card" + i}
                        >
                          <div className="card-body">
                            <React.Fragment>
                              <div
                                className="row justify-content-center"
                                style={{
                                  display: "block",
                                  margin: "auto",
                                  width: "100%"
                                }}
                              >
                                <div className="col s12">
                                  <table className="table table-adapt-query table-sm table-hover">
                                    <thead>
                                      <tr>
                                        <th scope="col">ID Movimentação</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Destinatário</th>
                                        <th scope="col">Descrição</th>
                                        <th scope="col">Patrimônio</th>
                                        <th scope="col">Observação</th>
                                        <th scope="col">
                                          <i>Status</i>
                                        </th>
                                        <th scope="col">
                                          <i>Info</i>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr key={i}>
                                        <td
                                          style={{
                                            fontWeight: "bolder"
                                          }}
                                        >
                                          {item.id_movimentacao}
                                        </td>
                                        <td>{item.tipo.toUpperCase()}</td>
                                        <td>
                                          {item.destino
                                            .toUpperCase()
                                            .replace(".", " ")}
                                        </td>
                                        <td>
                                          {item.descricao &&
                                            (item.descricao.length <= 15 ? (
                                              item.descricao
                                            ) : (
                                              <textarea
                                                style={{ border: "none" }}
                                                className="form-control white"
                                                id="view_descricao"
                                                maxLength="100"
                                                value={item.descricao}
                                                readOnly
                                              />
                                            ))}
                                        </td>
                                        <td>
                                          {item.patrimonio ? (
                                            item.patrimonio.length <= 15 ? (
                                              item.patrimonio
                                            ) : (
                                              <textarea
                                                style={{ border: "none" }}
                                                className="form-control white"
                                                id="view_patrimonio"
                                                maxLength="30"
                                                value={item.patrimonio}
                                                readOnly
                                              />
                                            )
                                          ) : (
                                            "----"
                                          )}
                                        </td>
                                        <td>
                                          {item.observacao ? (
                                            item.observacao.length <= 15 ? (
                                              item.observacao
                                            ) : (
                                              <textarea
                                                style={{ border: "none" }}
                                                className="form-control white"
                                                id="view_observacao"
                                                maxLength="1000"
                                                value={item.observacao}
                                                readOnly
                                              />
                                            )
                                          ) : (
                                            "----"
                                          )}
                                        </td>
                                        <td>
                                          {statusItem
                                            .filter(
                                              status =>
                                                status.id_status === item.status
                                            )
                                            .map((status, k) => (
                                              <span key={k}>
                                                <i
                                                  style={
                                                    item.status === 4
                                                      ? {
                                                          color: "red"
                                                        }
                                                      : item.status === 3
                                                      ? {
                                                          color: "green"
                                                        }
                                                      : item.status === 2
                                                      ? {
                                                          color: "tomato"
                                                        }
                                                      : item.status === 1
                                                      ? {
                                                          color: "#357ae8"
                                                        }
                                                      : {
                                                          color: "black"
                                                        }
                                                  }
                                                >
                                                  {status.status.toUpperCase()}
                                                </i>
                                              </span>
                                            ))}
                                        </td>
                                        <td>
                                          <MdInfo
                                            style={{
                                              fontSize: "1.2rem"
                                            }}
                                            onClick={() => showInfo(item)}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </React.Fragment>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              ) : (
                <p style={{ paddingTop: "25px" }}>
                  Nenhum registro encontrado.
                </p>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ListItems;
